<template>
    <div>
        <v-toolbar dense color="primary" flat app :clipped-left="clipped" dark tabs>

            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Ordem de Serviço</v-toolbar-title>

            <v-spacer/>

            <v-btn icon @click.stop="finalize()">
                <v-icon>done</v-icon>
            </v-btn>

            <v-menu v-if="ordem" offset-y>
                <v-btn icon slot="activator" dark>
                    <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list >
                    <v-list-tile :key="'map'" @click="maps()">
                        <!--<v-list-tile-title>-->
                            <v-icon dark left>place</v-icon> Acessar no Mapa
                        <!--</v-list-tile-title>-->
                    </v-list-tile>
                    <v-list-tile :key="'evento'" @click="eventos()" v-if="ordem.tipo_contrato === 'MONITORAMENTO' || ordem.tipo_contrato === 'VIDEO'  || ordem.tipo_contrato === 'VENDA'">
                        <!--<v-list-tile-title>-->
                        <v-icon dark left>place</v-icon> Últimos Eventos
                        <!--</v-list-tile-title>-->
                    </v-list-tile>
                    <v-list-tile :key="'frustrada'" @click="frustrada()" v-if="ordem.retirada_equipamento">
                        <!--<v-list-tile-title>-->
                        <v-icon dark left>clear</v-icon> Marcar Frustrada
                        <!--</v-list-tile-title>-->
                    </v-list-tile>
                </v-list>
            </v-menu>

            <v-tabs
                    v-if="ordem && ordem.tipo_contrato !== 'INTERNET'"
                    color="primary"
                    slot="extension"
                    grow
                    v-model="tab"
            >
                <v-tabs-slider color="yellow"/>

                <v-tab :key="'dados'" class="white--text">
                    Dados
                    <!--<v-icon class="white--text">description</v-icon>-->
                </v-tab>

                <v-tab :key="'user'" class="white--text">
                    Usuários
                    <!--<v-icon class="white--text">perm_identity</v-icon>-->
                </v-tab>

                <v-tab :key="'zonas'" class="white--text">
                    Zonas
                    <!--<v-icon class="white--text">camera_rear</v-icon>-->
                </v-tab>

                <v-tab :key="'map'" class="white--text" v-if="ordem.latlng && ordem.latlng.longitude">
                    Mapa
                    <!--<v-icon class="white--text">map</v-icon>-->
                </v-tab>

            </v-tabs>
        </v-toolbar>

        <v-tabs-items v-model="tab" v-if="ordem && ordem.tipo_contrato !== 'INTERNET'">

            <v-tab-item :key="'dados'">
                <dados-ordem :ordem="ordem" />
            </v-tab-item>

            <list-usuarios :usuarios="ordem.usuarios"/>

            <list-zonas :zonas="ordem.zonas"/>

            <v-tab-item :key="'map'" v-if="ordem.latlng">
                <map-caixa :lat="ordem.latlng.latitude" :lng="ordem.latlng.longitude"/>
            </v-tab-item>

        </v-tabs-items>

        <dados-ordem :ordem="ordem" v-else-if="ordem && ordem.tipo_contrato === 'INTERNET'" />

        <v-layout pa-2 v-if="latlng" row justify-center>
            <v-dialog v-model="latlng" persistent max-width="290">
                <v-btn color="primary" dark slot="activator">Open Dialog</v-btn>
                <v-card>
                    <v-card-title class="headline">Maps</v-card-title>
                    <v-card-text>Latitude e Longitude não cadastrada</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat @click.native="latlng = false">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<script>
    import ListUsuarios from "../components/ordem/ListUsuarios"
    import ListZonas from "../components/ordem/ListZonas"
    import MapCaixa from "../components/caixa/MapCaixa"
    import DadosOrdem from "../components/ordem/DadosOrdem"
    import { Ordens } from "../class/ordens"
    import { Sync } from "../class/sync";
    import { date } from "../filters"
    import { sortBy } from "lodash-es"

    export default {
        name: "ver-ordem",
        components: {
            ListUsuarios, ListZonas, DadosOrdem, MapCaixa
        },
        data () {
            return {
                tab: 0,
                clipped: true,
                latlng: null,
                error: null,
                ordem: null
            }
        },
        filters: {
            date
        },
        async beforeMount () {
            try {
                let ordem = await Ordens.get(parseInt(this.$route.params.id));
                if (ordem) {
                    // eslint-disable-next-line no-undef
                    ordem.usuarios = sortBy(ordem.usuarios, ["usuario", "nome"]);
                    // eslint-disable-next-line no-undef
                    ordem.zonas = sortBy(ordem.zonas, ["numero", "setor"]);

                    console.log(ordem);

                    this.ordem = ordem;
                    if (ordem.tipo !== "VENDA") {
                        if (!ordem.latlng || !ordem.latlng.latitude) {
                            this.dialog = true
                        }
                    }
                } else {
                    this.goBack()
                }
            } catch (e) {
                console.error(e);
                this.goBack()
            }
        },
        methods: {
            finalize: function () {
                if (this.ordem.tipo_contrato === "INTERNET" && this.ordem.instalacao) {
                    this.$router.push("/finalizar/internet/" + this.$route.params.id)
                } else {
                    this.$router.push("/finalizar/" + this.$route.params.id)
                }
            },
            goBack: function () {
                this.$router.push("/list-ordens")
            },
            toLatLong: function () {
                this.$router.push("/latlong/" + this.$route.params.id)
            },
            openLatLong: function () {
                this.dialog = false;
                this.toLatLong()
            },
            frustrada: async function () {
                try {
                    let dados = {
                        id_ordem_servicos: this.ordem.id_ordem_servico,
                        action: 'VISITA_FRUSTRADA'
                    };
                    let key = await Sync.add(dados);
                    await Sync.syncOne(key, this.$socket);
                    this.goBack();
                } catch (e) {
                    console.error(e);
                }
            },
            maps: function () {
                if (this.ordem.latlng && this.ordem.latlng.latitude) {
                    // window.open("google.navigation:q=" + this.ordem.geocode.latitude + "," + this.ordem.geocode.longitude);
                    window.open("https://www.google.com/maps/dir/?api=1&destination=" + this.ordem.latlng.latitude + "," + this.ordem.latlng.longitude)
                } else {
                    this.latlng = true
                }
            },
            eventos: function () {
                this.$router.push("/eventos/" + this.$route.params.id)
            }
        }
    }
</script>
